// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-7947981d]{font-family:Vazir,serif!important;max-width:100%;overflow:hidden;white-space:break-spaces;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1}", ""]);
// Exports
module.exports = exports;
